import React, { useEffect, useLayoutEffect } from 'react';
import { useSession } from '@/providers/Session.provider';
import { useLogTimestamp } from '@/providers/LogTimestamp.provider';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { useDatadogLog } from '@/hooks/useDatadogLog';

export default function SessionManager({ children }: { children: React.ReactNode }) {
  const { startSession, endSession } = useSession();
  const { updateTimestamp } = useLogTimestamp();
  const { isAuthenticated } = usePartnerLogin();
  const { datadogLog } = useDatadogLog();

  useLayoutEffect(() => {
    if (isAuthenticated) {
      startSession();
      updateTimestamp(Date.now());
    } else endSession();
  }, [isAuthenticated, startSession]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      datadogLog({
        message: 'Session closed',
        payload: {},
        actionType: 'End',
      });
      endSession();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  });

  return <>{children}</>;
}
